import { gclidFromQueryParam } from "@capi/types";
import { CookieSetOptions } from "universal-cookie";

interface PersistGclidFromUrlParams {
  /** The full URL to read the `gclid` query param from (e.g. `globalThis.location.href`). */
  url: string | undefined;
  /** The current value of the `gclid` cookie, if any. */
  currentGclid: string | undefined;
  /** Cookie setter (e.g. react-cookie's `setCookie`). */
  setCookie: (name: "gclid", value: string, options?: CookieSetOptions) => void;
  /** Options to apply when writing the cookie (domain, maxAge, etc.). */
  cookieOptions: CookieSetOptions;
  logger: (message: string, exception: unknown) => void;
}

/** Captures the Google Ads `gclid` from the given URL into a first-party cookie
 * so it survives until checkout (by then the `?gclid=` query param is usually
 * gone). No-ops when there is no gclid in the URL, or when the cookie already
 * holds the same value. A new gclid is written once (latest-click-wins). */
export function persistGclidFromUrl({
  url,
  currentGclid,
  setCookie,
  cookieOptions,
  logger,
}: PersistGclidFromUrlParams): void {
  const result = gclidFromQueryParam(url, logger);
  if (!result) { return; }
  // Only overwrite if it's a new gclid (most recent click wins)
  if (currentGclid === result.gclid) { return; }
  setCookie("gclid", result.gclid, cookieOptions);
}
